// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "TooltipIcon__textCenter__GBNBT";
export const outerWrapper = "TooltipIcon__outerWrapper__WGvEX";
export const container = "TooltipIcon__container__LgyMT";
export const iconWrapper = "TooltipIcon__iconWrapper__fiO0q";
export const tooltipIcon = "TooltipIcon__tooltipIcon__IhZkk";
export const transparent = "TooltipIcon__transparent__R3awV";
export const wide = "TooltipIcon__wide__kPKSl";
export const tooltipIconWrapper = "TooltipIcon__tooltipIconWrapper__oUGNC";
export const tooltipOpened = "TooltipIcon__tooltipOpened__s8OGU";
export const tooltipContainer = "TooltipIcon__tooltipContainer__I-QL9";
export const incorrect = "TooltipIcon__incorrect__uG27v";
export const onBottom = "TooltipIcon__onBottom__F6khh";
export const warning = "TooltipIcon__warning__j74X-";
export const danger = "TooltipIcon__danger__GRUxn";
export const secure = "TooltipIcon__secure__RB+5c";
export const message = "TooltipIcon__message__iVTBY";